import React, { useContext } from "react";
import "./contact_me.scss";

import useObserver from "../../utilities/UseObserver";
import FormComponent from "../../components/Form/Form_Component";
import languageContext from "../../context/languageContext";

const Contact_Me = () => {
  const { language } = useContext(languageContext);

  const [isIntersecting, refElement] = useObserver({
    rootMargin: "0px",
    root: null,
    threshold: 0.2,
  });

  let classNameEffect = isIntersecting ? "--in" : "--out";

  return (
    <section className="contact-me" id="contact-page" ref={refElement}>
      <div
        className={`contact-me__form-component contact-me__form-component${classNameEffect}`}
      >
        <FormComponent />
      </div>
      <div
        className={`contact-me__creative-side contact-me__creative-side${classNameEffect}`}
      >
        <p className="phrase-slogan heading-secondary">
          "{language.contactPhrase}"
        </p>
      </div>
    </section>
  );
};

export default Contact_Me;
